module.exports = __webpack_public_path__ + "img/G_lineG_sel@2x.2c8d84aa.png";